import { mutatorAction } from 'satcheljs';
import { cancelAllRowAnimationsForAnimation } from '../utils/cancelAllRowAnimationsForAnimation';
import { mailListItemAnimationStore } from '../store/Store';

export const clearAnimationStore = (): void => {
    if (mailListItemAnimationStore().activeAnimations.length > 0) {
        const activeAnimations = mailListItemAnimationStore().activeAnimations;

        for (const activeAnimation of activeAnimations) {
            cancelAllRowAnimationsForAnimation(activeAnimation);
        }

        for (const activeAnimation of activeAnimations) {
            activeAnimation.animationCallback?.();
        }
    }

    if (mailListItemAnimationStore().completedAnimations.length > 0) {
        const completedAnimations = mailListItemAnimationStore().completedAnimations;

        // For this one, we just need to cancel all the row animations. Callbacks have already been executed for all completed animations.
        for (const completedAnimation of completedAnimations) {
            cancelAllRowAnimationsForAnimation(completedAnimation);
        }
    }

    if (mailListItemAnimationStore().pendingAnimations.length > 0) {
        const pendingAnimations = mailListItemAnimationStore().pendingAnimations;

        for (const pendingAnimation of pendingAnimations) {
            pendingAnimation.animationCallback?.();
        }
    }
    clearAnimationStoreMutator();
};

const clearAnimationStoreMutator: () => void = mutatorAction(
    'clearAnimationStoreMutator',
    (): void => {
        // Skip resetting already-empty observable arrays to avoid triggering unnecessary MobX reactions
        if (
            !mailListItemAnimationStore().activeAnimations ||
            mailListItemAnimationStore().activeAnimations.length > 0
        ) {
            mailListItemAnimationStore().activeAnimations = [];
        }
        if (
            !mailListItemAnimationStore().completedAnimations ||
            mailListItemAnimationStore().completedAnimations.length > 0
        ) {
            mailListItemAnimationStore().completedAnimations = [];
        }
        if (
            !mailListItemAnimationStore().pendingAnimations ||
            mailListItemAnimationStore().pendingAnimations.length > 0
        ) {
            mailListItemAnimationStore().pendingAnimations = [];
        }
    }
);
